import LocalizedStrings from "react-localization";

export const BisListingNotMappedStrings = new LocalizedStrings({
  en: {
    title: "List BIS Not Mapped",
    IdBIS: "BIS ID",
    LabelBIS: "BIS Label",
    search: "Search",
    resetFiltersButton: "Reset",
    associer: "associate",
    associationInProgress: "Association ...",
    errors: {
      associationFailed: "Failed to associate BIS.",
    },
  },
  fr: {
    title: "Liste de(s) sites BIS non mappé(s)",
    IdBIS: " Id BIS",
    LabelBIS: "Libellé BIS",
    search: "Rechercher",
    resetFiltersButton: "Réinitialiser",
    associer: "associer",
    associationInProgress: "Association en cours...",
    errors: {
      associationFailed: "Erreur lors de l'association des BIS.",
    },
  },
});
